import { Component, input, output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { UserCreate } from '@app/models/user.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-password-reset-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class PasswordResetFormComponent {
  initialValue = input<{ password: string, passwordConfirm: string}>();
  formChange = output<{ password: string, passwordConfirm: string}>();
  formValid = output<boolean>();

  passwordForm = new FormGroup<AutoForm<{ password: string, passwordConfirm: string}>>({
    password: new FormControl<string>('', { validators: [Validators.required, Validators.minLength(6)], nonNullable: true}),
    passwordConfirm: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
  }, { validators: this.checkPasswords });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.passwordForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.passwordForm.valid);
    this.formChange.emit(<{ password: string, passwordConfirm: string}>this.passwordForm.value);
  }

  checkPasswords (group: AbstractControl):  ValidationErrors | null { 
    let pass = group.get('password')?.value;
    let confirmPass = group.get('passwordConfirm')?.value;
    return pass == confirmPass ? null : { notSame: true };
  }
}